// components/NovaDislikeButtonModal.js
import React, { useState } from "react";
import { ReactComponent as NovaIcon } from "resources/icons/nova.svg";
import { TextArea } from "DesignSystem/Input";
import { PrimaryButton, SecondaryButton } from "DesignSystem/Buttons";
const NovaDislikeButtonModal = ({
  visible,
  handleSubmitFeedback,
  handleCancelFeedback,
  isDraggedToEdge,
  dir,
}) => {
  const [userFeedback, setUserFeedback] = useState("");

  if (!visible) return null;

  return (
    <div
      className={`position-absolute nova-dislike-button-modal ${
        isDraggedToEdge ? (dir === "rtl" ? "shifted-rtl" : "shifted-ltr") : ""
      } ${dir === "rtl" ? "modal-rtl" : "modal-ltr"}`}
      role="dialog"
      aria-modal="true"
      aria-label="Help us Improve"
    >
      <div className="mb-10">
        <NovaIcon className="display-inline" />
        <div className="fs-medium fw-500 ml-30 nova-feedback-title">
          Help us Improve
        </div>
      </div>
      <div>
        <div className="fs-medium fw-500 color-faded">What went wrong ?</div>
        <TextArea
          value={userFeedback}
          onChange={(e) => setUserFeedback(e.target.value)}
        />
      </div>
      <div className="flex justify-end mt-10">
        <SecondaryButton
          className="pt-2 nova-feedback-cancel-button"
          onClick={handleCancelFeedback}
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton
          className="pt-2 nova-feedback-submit-button"
          onClick={() => handleSubmitFeedback(userFeedback)}
          disabled={!userFeedback.trim()}
        >
          Submit
        </PrimaryButton>
      </div>
    </div>
  );
};

export default NovaDislikeButtonModal;
